<template>
  <div>
    <div style="margin-top: 20px; padding: 10px;position:fixed;top:35px;left:0px;bottom:0px;width:100%;height:50px;background-color:white;z-index:999;">
      <el-form :inline="true">
        <el-form-item label="服务名称">
          <el-input
            v-model="search.serviceName"
            placeholder="请输入服务名称..."
          ></el-input>
        </el-form-item>
        <el-form-item label="环境">
          <el-input
            v-model="search.env"
            placeholder="请输入服务名称..."
          ></el-input>
        </el-form-item>
        <el-form-item label="日志时间:">
          <div class="block">
          <span class="demonstration"></span>
          <el-date-picker
            v-model="dateBetween"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            default-time="['12:00:00', '08:00:00']"
          >
          </el-date-picker>
        </div>
        </el-form-item>
        <el-form-item label="显示行数:">
          <el-input
            v-model="search.lines"
            placeholder="请输入显示行数..."
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="doSearch">查询</el-button>
          <el-button type="info" @click="reset">重置</el-button>
          <el-button type="success" @click="clear">清空</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top:45px">
      <div v-for="item in logs" :key="item.id" style="padding:10px;background:black;color:rgb(130 131 130)">{{item.content}}</div>
    </div>
  </div>
</template>

<script>
import MonitorLogApi from "@/api/MonitorLogApi";
export default {
  name: "CodeList",
  props: {
    msg: String,
  },
  components: {
  },
  data() {
    return {
        search:{
          "serviceName":"monitor",
          "startTime":"",
          "endTime":"",
          "env":"dev",
          "lines":100
        },
        logs:[],
        dateBetween: [],
        pickerOptions: {
        shortcuts: [
          {
            text: "最近1分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 1 );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近3分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 3 );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近5分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 5 );
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近10分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 10);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近30分钟",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 60 * 1000 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近1小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 1);
              picker.$emit("pick", [start, end]);
            },
          },

          {
            text: "最近2小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600  * 1000 * 2);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近3小时",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600  * 1000 * 3);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted(){
    let date = new Date();
    let defalutStartTime = date.getTime() - 5 * 60 * 1000; // 转化为时间戳
    let startDateNs = new Date(defalutStartTime);
    this.dateBetween = [startDateNs, date];
    this.search.startTime =startDateNs;
    this.search.endTime = date;
  },
  methods: {
    refresh(){
        MonitorLogApi.queryLog(this.search).then((resp)=>{
            if(resp.state=="OK"){
                this.logs = resp.data;
            }
        })
    },
    doSearch(){
      this.search.startTime =this.dateBetween[0];
      this.search.endTime = this.dateBetween[1];
      this.refresh();
    },
    clear(){
      this.logs = []
    },
    reset(){
      this.search = {
          "serviceName":"",
          "startTime":"",
          "endTime":"",
          "env":"dev",
          "lines":100
        }
    }
  },
};
</script>